import React, { useContext, useEffect, useState } from 'react'
import moment from 'moment'
import { Box, Chip, IconButton, Stack, Typography } from '@mui/material'
import { ArrowBack, ExitToApp } from '@mui/icons-material'
import { SiteModeContext } from '../../../components/mainFrame/MainFrame'
import { useNavigate } from 'react-router-dom'
import { TenantSettingsContext } from '../../../App'
import AmbuNetLogo from '../../../assets/images/ambunetLogo.png'

const CountChip = ({ title, number, color }) => (
  <Chip
    label={`${title} ${number || 0}`}
    sx={{
      bgcolor: number ? `${color}.main` : '#35353542',
      color: '#fff',
      borderRadius: 1,
    }}
    variant={number ? 'filled' : 'outlined'}
  />
)

const Header = ({ counts }) => {
  const { setSiteMode } = useContext(SiteModeContext)
  const { orgSettings } = useContext(TenantSettingsContext)?.orgConfig
  const [currentTime, setCurrentTime] = useState(moment())

  const navigate = useNavigate()
  useEffect(() => {
    const timer = setInterval(() => setCurrentTime(moment()), 1000)
    return () => clearInterval(timer)
  }, [])

  const leave = () => {
    setSiteMode('normal')
    navigate('/pts/planning')
  }

  return (
    <Stack
      direction={{ xs: 'column', md: 'row' }}
      alignItems={{ xs: 'stretch', md: 'center' }}
      justifyContent="space-between"
      gap={{ xs: 1, md: 0 }}
      sx={{
        // mb: 2,
        p: { xs: 1.5, md: 2 },
        backgroundColor: 'primary.main',
        color: '#fff',
        borderRadius: 0,
        boxShadow: '0 4px 10px rgba(0,0,0,0.12)',
      }}
    >
      <Stack
        direction="row"
        alignItems="flex-start"
        justifyContent="space-between"
        gap={1}
      >
        <Stack minWidth={0}>
          <Typography
            color="contrast.main"
            variant="body2"
            fontWeight={800}
            fontSize={{ xs: 16, md: 20 }}
          >
            PATIENT TRANSPORT
          </Typography>
          <Stack
            direction="row"
            alignItems="center"
            gap={{ xs: 1, md: 2 }}
            flexWrap="wrap"
          >
            <Typography
              variant="h6"
              fontWeight={700}
              color="white"
              fontSize={{ xs: '1rem', md: '1.25rem' }}
            >
              {currentTime.format('dddd, D MMM YYYY')}
            </Typography>
            <Typography
              variant="h6"
              fontWeight={400}
              color="white"
              fontSize={{ xs: '1rem', md: '1.25rem' }}
            >
              {currentTime.format('HH:mm:ss')}
            </Typography>
          </Stack>
        </Stack>
        {/* Phone-only back control: the header stacks on small screens and the
            exit button below would otherwise sit at the bottom of the chip row */}
        <IconButton
          onClick={leave}
          aria-label="Back to planning"
          sx={{
            display: { xs: 'inline-flex', md: 'none' },
            backgroundColor: 'contrast.main',
            borderRadius: 1,
            flexShrink: 0,
          }}
          size="small"
        >
          <ArrowBack sx={{ color: 'white' }} />
        </IconButton>
      </Stack>
      <Stack spacing={1}>
        <Stack
          direction="row"
          alignItems="flex-end"
          justifyContent="space-between"
        >
          <Typography
            variant="body2"
            color="white"
            fontWeight={800}
            fontSize="1rem"
          >
            {orgSettings?.orgName ?? ''}
          </Typography>
          <Stack
            alignItems="flex-end"
            sx={{ display: { xs: 'none', md: 'flex' } }}
          >
            <Stack direction="row" alignItems="center" gap={0.5} sx={{}}>
              <Box
                sx={{
                  fontFamily: 'moonlander',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  color: '#d8d8d8',
                }}
              >
                <Stack alignItems="flex-end">
                  <Typography fontSize={8} color="white" pr={2}>
                    Powered by
                  </Typography>
                  <Box display="flex" gap={0}>
                    AmbuNet
                    <Typography fontFamily="arial" fontSize="0.75rem">
                      &reg;
                    </Typography>
                  </Box>
                </Stack>
                <Box component="img" width={30} src={AmbuNetLogo} />
              </Box>
            </Stack>
          </Stack>
        </Stack>
        <Stack direction="row" gap={1} alignItems="center" flexWrap="wrap">
          <CountChip
            title="Waiting"
            number={counts.Waiting}
            color="secondary"
          />
          <CountChip title="Active" number={counts.Active} color="anBlue" />
          <CountChip
            title="Complete"
            number={counts.Complete}
            color="anGreen"
          />
          <CountChip
            title="Exceptions"
            number={counts.Exceptions}
            color="anPurple"
          />
          <CountChip
            title="Unassigned"
            number={counts.Unassigned}
            color="anRed"
          />
          <IconButton
            onClick={leave}
            sx={{
              display: { xs: 'none', md: 'inline-flex' },
              backgroundColor: 'contrast.main',
              borderRadius: 1,
            }}
            size="small"
          >
            <ExitToApp sx={{ color: 'white' }} />
          </IconButton>
        </Stack>
      </Stack>
    </Stack>
  )
}

export default Header
